import React from 'react';
import { PRODUCT_LINES_CONTENT_MAP } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { observer } from 'mobx-react-lite';
import { ProductLineHeaderStyled, ProductLineTitleStyled, TitleTextStyled } from './styles';
import { OVERRIDE_RATES_PRODUCT_LINE_HEADER_TEST_ID } from '../constants';

interface Props {
  productLineId: ProductLineId;
}

const ProductLineHeader: React.FC<Props> = observer(({ productLineId }) => {
  const productLineName = PRODUCT_LINES_CONTENT_MAP[productLineId].label;

  return (
    <ProductLineHeaderStyled data-test-id={OVERRIDE_RATES_PRODUCT_LINE_HEADER_TEST_ID}>
      <ProductLineTitleStyled>
        {PRODUCT_LINES_CONTENT_MAP[productLineId].icon('2.4rem')}
        <TitleTextStyled>{productLineName}</TitleTextStyled>
      </ProductLineTitleStyled>
    </ProductLineHeaderStyled>
  );
});

export default ProductLineHeader;
